// Shared helper — turns the `previous_login` payload from /api/auth/crew-login
// into a human-readable "Last login: 8 min ago" / "today at 3:14 PM" string.
// Returns null when there's no prior login (first-ever sign-in).
const STORE_TIMEZONE = "America/Denver";

export default function formatLastLogin(prev) {
  if (!prev || !prev.timestamp_utc) return null;
  try {
    const then = new Date(prev.timestamp_utc);
    const now = new Date();
    const diffMin = Math.floor((now - then) / 60000);
    if (diffMin < 1) return "Last login: just now";
    if (diffMin < 60) return `Last login: ${diffMin} min ago`;
    const today = new Date().toLocaleDateString("en-CA", { timeZone: STORE_TIMEZONE });
    const formattedDate = prev.date
      ? (() => {
          const parts = prev.date.split("-");
          return parts.length === 3
            ? `${parts[1]}/${parts[2]}/${parts[0].slice(2)}`
            : prev.date;
        })()
      : "";
    const prefix = prev.date === today ? "today" : formattedDate;
    const timeStr = prev.timestamp_mst || then.toLocaleTimeString();
    return `Last login: ${prefix} at ${timeStr}`;
  } catch {
    return null;
  }
}
